import {
    LOG_OUT, STAFF_DATA_KPI, STAFF_LIST_CORRECTION, 
    MESSAGE_LIST, ALL_CORRECTION_DATA
} from "./ActionTypes";
import StaffDataService from "../services/StaffDataService";
import {getUser} from "../utils/TokenManager";

// Set Staff kpi (either all or of one compensation profile)
const staffKPI = (staffKPIList) => ({type: STAFF_DATA_KPI, staffKPIList});

// Set Message List 
const messageList = (msgListData) => ({type: MESSAGE_LIST, msgListData});

// Compare Message for sorting
const compareMessage = (a, b) => {
    if (a.message.toUpperCase() < b.message.toUpperCase()) {
        return -1;
    }
    if (a.message.toUpperCase() > b.message.toUpperCase()) {
        return 1;
    }
    return 0;
};

// Get user list with correction panding status
export const getUsers = (locationId) => (
    async (dispatch) => {
        try {
            const userListData = await StaffDataService.getUserList(locationId);

            if (getUser()['app-version'] !== userListData.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === userListData.status) {
                dispatch({type: STAFF_LIST_CORRECTION, userListData: userListData.data.user});
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

// Get all user list if owner is logged in otherwise get only admin's location's users
export const getUserListToSendMesasage = () => (
    async (dispatch) => {
        try {
            const userListData = await StaffDataService.getUserListToSendMesasage();

            if (getUser()['app-version'] !== userListData.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === userListData.status) {
                return userListData.data.user;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getStaffKPIAll = (userId) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.getStaffKPIAll(userId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch(staffKPI(result.data));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getStaffCompKPI = (profileId) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.getStaffCompKPI(profileId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch(staffKPI(result.data));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

// Get correction requests of a user
export const getCorrectionRequests = (userId) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.getCorrections(userId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                dispatch({type: ALL_CORRECTION_DATA, list: result.data});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const putCorrectionApprove = (
    userId, requestData, oldRequestListProps, oldUserListProps
) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.approveCorrections(
                userId, requestData.id, requestData
            );
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                let oldRequestList = oldRequestListProps.map(request => ({...request}));
                let correctionRequestList = oldRequestList.map(request => {
                    if(result.data.id === request.id) {
                        return {...result.data};
                    } 
                    return {...request};
                });
                let oldUserList = oldUserListProps.map(user => ({...user}));
                let newUserList = oldUserList.map(user => {
                    if(userId === user.id) {
                        let newUser = {...user};
                        newUser['correction_pending'] = user.correction_pending - 1;
                        return newUser; 
                    }
                    return user;
                });
                dispatch({type: STAFF_LIST_CORRECTION, userListData: newUserList});
                dispatch({type: ALL_CORRECTION_DATA, list: correctionRequestList});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const deleteCorrectionRequest = (
    userId, requestId, oldRequestListProps, oldUserListProps
) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.deleteCorrectionRequest(userId, requestId);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }
            if (200 === result.status) {
                let oldRequestList = oldRequestListProps.map(request => ({...request}));
                let correctionRequestList = oldRequestList.map(request => {
                    if(requestId === request.id) {
                        return {...result.data};
                    } 
                    return {...request};
                });
                let oldUserList = oldUserListProps.map(user => ({...user}));
                let newUserList = oldUserList.map(user => {
                    if(userId === user.id) {
                        let newUser = {...user};
                        newUser['correction_pending'] -= 1;
                        return newUser; 
                    }
                    return user;
                });
                dispatch({type: STAFF_LIST_CORRECTION, userListData: newUserList});
                dispatch({type: ALL_CORRECTION_DATA, list: correctionRequestList});
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getMessageList = (locationId) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.getMessageList(locationId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                dispatch(messageList(result.data.message));
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const saveNewMessage = (locationId, messageData, oldMsgList) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.postMessageItem(locationId, messageData);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (201 === result.status) {
                let newMsgList = [result.data.message, ...oldMsgList];
                newMsgList.sort(compareMessage);
                dispatch(messageList(newMsgList));
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const saveExistingMessage = (msgId, messageData, oldMsgList) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.updateMessage(msgId, messageData);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                let newMsgList = oldMsgList.map(msg => {
                    if(msgId === msg.id) {
                        return {...result.data.message};
                    }
                    return {...msg};
                });
                newMsgList.sort(compareMessage);
                dispatch(messageList(newMsgList));
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const deleteExistingMessage = (msgId, oldMsgList) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.deleteMessage(msgId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                let newMsgList = oldMsgList.filter(msg => {
                    if(msgId !== msg.id) {
                        return {...msg};
                    }
                });
                dispatch(messageList(newMsgList));
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getStaffDataList = (userId, active=1, page=1) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.getStaffDataList(userId, active, page);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return result.data;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const deleteOrRecoverStaffData = (userId, requsetObj) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.updateStaffDataList(userId, requsetObj);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);


export const getCorrectionDataList = (userId) => (
    async (dispatch) => {
        try {
            const result = await StaffDataService.getCorrectionDataList(userId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch({type: LOG_OUT});
            }

            if (200 === result.status) {
                dispatch({type: ALL_CORRECTION_DATA, list: result.data})
                return true;
            } 
        } catch (error) {
            if(401 === error.response.status) {
                dispatch({type: LOG_OUT});
                return false;
            }
            throw error.response;
        }

        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/StaffDataAction.js